import parentPath from "../path";

export const linkedinFiltersSubPath = "/linkedin-filters";
export const linkedinFiltersPath = `${parentPath}${linkedinFiltersSubPath}`;

export default linkedinFiltersPath;
